module.exports = __webpack_public_path__ + "img/Button-kosik-2021-04.ee385538.png";